import React, { Component } from "react";
import PropTypes from "prop-types";
import DayPicker from "react-day-picker";
import * as Utils from "react-day-picker";
import { injectIntl } from "react-intl";
import "react-day-picker/lib/style.css";
import "./DayPicker.scss";
import { getTranslatedDaysOfTheWeek, getTranslatedMonthsOfTheYear } from "../../utils/date";

export const DateUtils = Utils.DateUtils;
export const LocaleUtils = Utils.LocaleUtils;
export const NavbarPropTypes = Utils.NavbarPropTypes;

const FIRST_DAY = {
  es: 1,
  eu: 1,
  en: 0,
  de: 1,
  ca: 1,
  da: 1,
  ko: 1,
  pt: 1,
  nl: 1,
  ru: 1,
  it: 1,
  fr: 1,
};

class CustomDayPicker extends Component {
  constructor(props) {
    super(props);
    this.daypicker = React.createRef();
  }

  componentDidMount() {
    if (this.props.from) {
      this.daypicker.current.showMonth(this.props.from);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.advanceMonth !== this.props.advanceMonth) {
      this.daypicker.current.showMonth(this.props.advanceMonth);
    }
  }

  showMonth(...args) {
    this.daypicker.current.showMonth(...args);
  }

  render() {
    const {
      intl: { locale: appLocale, formatDate },
      property,
      ...otherProps
    } = this.props;
    const WEEKDAYS_LONG = {
      [appLocale]: getTranslatedDaysOfTheWeek(formatDate, null, "long", 0),
    };
    const WEEKDAYS_SHORT = {
      [appLocale]: getTranslatedDaysOfTheWeek(formatDate, null, "short", 0),
    };

    const MONTHS = {
      [appLocale]: getTranslatedMonthsOfTheYear(formatDate, null, "long"),
    };

    const localeUtils = {
      formatDay: (day, locale = "es") =>
        `${WEEKDAYS_LONG[locale][day.getDay()]}, ${day.getDate()} ${
          MONTHS[locale][day.getMonth()]
        } ${day.getFullYear()}`,
      formatMonthTitle: (day, locale) => `${MONTHS[locale][day.getMonth()]} ${day.getFullYear()}`,
      formatWeekdayShort: (index, locale) => WEEKDAYS_SHORT[locale][index],
      formatWeekdayLong: (index, locale) => WEEKDAYS_LONG[locale][index],
      getFirstDayOfWeek: locale => FIRST_DAY[locale],
    };
    return (
      <DayPicker
        locale={appLocale}
        localeUtils={localeUtils}
        ref={this.daypicker}
        className={property && "DayPicker-property"}
        {...otherProps}
      />
    );
  }
}

CustomDayPicker.propTypes = {
  intl: PropTypes.object,
  property: PropTypes.object,
  from: PropTypes.object,
  to: PropTypes.object,
  advanceMonth: PropTypes.object,
};

export default injectIntl(CustomDayPicker);
